import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import User from 'flarum/common/models/User';

/*
 * Un seul badge de groupe Flarum par utilisateur.
 *
 * Priorité :
 *   1  Administrateur
 *   4  Modérateur
 *   5  Membre d'honneur
 *   9  Membre régulier manuel
 *   6  Membre régulier
 *   8  Membre débutant manuel
 *   7  Membre débutant
 *
 * Les autres groupes, notamment les groupes techniques 10 et 11,
 * ne sont pas affichés.
 *
 * Les badges ajoutés par d'autres extensions (FoF Badges, etc.)
 * ne sont pas touchés.
 */

const priority = [1, 4, 5, 9, 6, 8, 7];
app.initializers.add('val-ui-highest-group-badge', () => {
  extend(User.prototype, 'badges', function (items) {
    const groups = this.groups();
    if (!groups) return;
    const validGroups = groups.filter(Boolean);
    const ids = validGroups.map(group => Number(group.id()));
    const keep = priority.find(id => ids.includes(id));
    validGroups.forEach(group => {
      const id = Number(group.id());
      if (id !== keep) {
        items.remove(`group${group.id()}`);
      }
    });
  });
});